@if (showNavbarFooter) {
  <app-navbar />
}
<router-outlet />
@if (showNavbarFooter) {
  <app-footer />
}
<app-toast />
